export default __webpack_public_path__ + "static/media/8.e9f9f950.png";